import React from "react";
import { Card, CardMedia } from "@mui/material";
import AppNavigation from "../navigation/AppNavigation";

const Card18Image = ({ card }) => {
  const { handleNavigation } = AppNavigation();
  const handleCardClick = () => {
    const onTap = card.cardData[0]?.data?.onTap;
    console.log("onTap",onTap);
    if (!onTap) {
      console.log("No onTap data found in card.");
     
      return;
    }

    handleNavigation(onTap); // Pass onTap to the navigation handler
  };

  return (
    <Card
      onClick={handleCardClick}
      sx={{
        marginBottom: 0,
        borderRadius: 2,
        overflow: "hidden",
        boxShadow: "0 0px 8px rgba(0, 0, 0, 0)",
        cursor: "pointer",
      }}
    >
      <CardMedia
        component="img"
        image={card.cardData[0]?.data?.imageUrl}
        alt="Arena Banner"
        sx={{
          width: "100%",
        }}
      />
    </Card>
  );
};

export default Card18Image;